export enum InspectUploadStatus {
  UploadingImages = "UploadingImages",
  UploadingData = "UploadingData",
  Failed = "Failed",
  FailedImages = "FailedImages",
  Success = "Success",
  Pending = "Pending"
}
